import { Button, Collapse } from '@material-ui/core';

import AdjustmentCatalogList from './adjustment.catalog.list.component';
import AdjustmentPreviewPanel from './adjustment.preview.panel.component';
import AdjustmentReasonField from './adjustment.reason.field.component';

const AUTHORIZERS = 'Raquel Albiero e José Vitor';

const PREVIEW_ANIMATION_MS = 260;

export default function AdjustmentSheetBody({ sheet }) {

    return (
        <>
            <AdjustmentCatalogList sheet={sheet} />

            <Collapse in={sheet.preview.hasChanges} timeout={PREVIEW_ANIMATION_MS} unmountOnExit>
                <div>
                    <AdjustmentPreviewPanel preview={sheet.preview} authorizers={AUTHORIZERS} />

                    <AdjustmentReasonField
                        reason={sheet.reason}
                        onChange={sheet.setReason}
                        isRequired={sheet.preview.requiresReason}
                    />

                    <div className="mt-4 flex flex-wrap justify-end gap-2">
                        <Button onClick={sheet.discard} disabled={sheet.isSaving}>Voltar como estava</Button>
                        <Button variant="contained" color="primary" disabled={!sheet.canApply} onClick={sheet.apply}>
                            {sheet.preview.requiresReason ? 'Autorizar e aplicar' : 'Aplicar'}
                        </Button>
                    </div>
                </div>
            </Collapse>
        </>
    );
}
